import { render, staticRenderFns } from "./AddCollection.vue?vue&type=template&id=5163af86"
import script from "./AddCollection.vue?vue&type=script&lang=js"
export * from "./AddCollection.vue?vue&type=script&lang=js"
import style0 from "./AddCollection.vue?vue&type=style&index=0&id=5163af86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports